<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panel expand :value="[true]">
          <v-expansion-panel-content>
            <div slot="header">
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex xl6 lg6 xs6>
                      <v-text-field v-model="filters.vehMake" :label="filtersLabel.vehMake" :error-messages="errors.collect('vehMake')" data-vv-name="vehMake" :data-vv-as="filtersLabel.vehMake" v-validate="'entry|max:20'"></v-text-field>
                    </v-flex>
                    <v-flex xl6 lg6 xs6>
                      <v-text-field v-model="filters.vehMakeDesc" :label="filtersLabel.vehMakeDesc" :error-messages="errors.collect('vehMakeDesc')" data-vv-name="description" :data-vv-as="filtersLabel.vehMakeDesc" v-validate="'name|max:40'"></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </form>
    </v-flex>
    <v-flex xs12 class="mt-3">
      <message :messages="messages"></message>
    </v-flex>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <div class="headline">Makes Listing</div>
            </div>
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table v-bind:headers="headers" v-bind:items="items" :total-items="totalItems" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="vehMake" :loading="loading" :no-data-text="noDataText">
            <template slot="headerCell" slot-scope="props">
              <v-tooltip bottom>
                <span slot="activator">
                  {{ props.header.text }}
                </span>
                <span>
                  {{ props.header.text }}
                </span>
              </v-tooltip>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">{{ props.item.vehMake }}</td>
              <td class="text-xs-left">{{ props.item.vehMakeDesc }}</td>
              <td class="text-xs-right" v-if="checkAccess(['vehicleReview'])">
                <table-action :rowData="props" review @review="doReview(props.item.vehMake)" remove @remove="doPromptRemove(props.item)"></table-action>
              </td>
            </template>
          </v-data-table>
          <v-btn color="primary" dark class="mb-2" @click="doNew()">
            New Make
            <v-icon right>mdi-plus</v-icon>
          </v-btn>
        </v-card>
        <v-dialog v-model="vehMakeDialog" width="800px" lazy v-if="checkAccess(['vehicleReview'])" persistent >
          <make-dialog :vehMakeForm="vehMakeForm" @close="doClose" :newMake="newMake"></make-dialog>
        </v-dialog>
        <confirm v-model="promptRemove" @ok="doRemove">
          All Vehicle Models under the selected Vehicle Make will also be deleted.
          <v-flex>({{deleteVehMake}})</v-flex>
        </confirm>
      </v-flex>
    </v-layout>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { expandURI, filterQuery } from '@/utils/ajax'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import MakeDialog from './MakeDialog'

export default {
  data() {
    return {
      headers: [
        { text: 'Make Code', align: 'left', value: 'vehMake' },
        { text: 'Make Description', align: 'left', value: 'vehMakeDesc' }
      ],
      totalItems: 0,
      filters: {
        vehMake: null,
        vehMakeDesc: null
      },
      filtersLabel: {
        vehMake: 'Make Code',
        vehMakeDesc: 'Make Description'
      },
      vehMakeForm: {
        makeCode: undefined,
        vehMakeDesc: undefined
      },
      vehMakeDialog: undefined,
      newMake: undefined,
      loading: false,
      promptRemove: false,
      selectedVehMake: undefined,
      deleteVehMake: ''
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      const apiUrl = this.$store.state.vehicle.menu.getVehMakes
      if (apiUrl) {
        try {
          this.loading = true
          const { page, rowsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: rowsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((Make) => {
                const convertMake = {
                  vehMake: Make.vehMake,
                  vehMakeDesc: Make.vehMakeDesc
                }
                this.items.push(convertMake)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fullMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    },
    doClearFilters() {
      this.filters.vehMake = null
      this.filters.vehMakeDesc = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    doClose() {
      this.vehMakeDialog = false
      this.newMake = false
      this.$validator.reset()
      this.fetchData()
    },
    doNew() {
      this.$validator.reset()
      this.vehMakeDialog = true
      this.newMake = true
    },
    async doReview(vehMake) {
      const apiURI = this.$store.state.vehicle.menu.getVehMake
      const expand = {
        Make: vehMake
      }
      if (apiURI) {
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.vehMakeForm.vehMake = data.Make.vehMake
          this.vehMakeForm.vehMakeDesc = data.Make.vehMakeDesc
        }
        this.vehMakeDialog = true
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedVehMake = data
        this.deleteVehMake = data.vehMake + ' - ' + data.vehMakeDesc
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.vehicle.menu.deleteVehMake
      if (apiURI) {
        this.loading = true
        const expand = {
          vehMake: this.selectedVehMake.vehMake
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          this.notify(result.data)
          // Reinit
          this.fetchData()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
    }
  },
  mounted() {
    // Fetch Users Data
    this.fetchData(true)
  },
  created() {
    if (this.checkAccess(['vehicleReview'])) {
      this.headers.push(TableConst.tableActionHeader)
    }
  },
  components: {
    MakeDialog: MakeDialog
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style lang="scss">
</style>
